import { useState, useEffect, useRef } from "react";
import isDev, { isTestEndpoint } from "../helpers/isDev";
import Intro from "./BuyFlowStep/Intro";
import AddressUnavailable from "./BuyFlowStep/AddressUnavailable";
import { BeatLoader, BarLoader, CircleLoader, MoonLoader, BounceLoader } from "react-spinners";
import PreSale from "./BuyFlowStep/PreSale";
import PreSaleNotify from "./BuyFlowStep/PreSaleNotify";
import { getCookie, setCookie } from "../helpers/cookies";
import useStateMachineWrapper from "../helpers/useStateMachineWrapper";
import ChooseInternet from "./BuyFlowStep/ChooseInternet";
import PreSaleNotifyComplete from "./BuyFlowStep/PreSaleNotifyComplete";
import AddressAvailable from "./BuyFlowStep/AddressAvailable";
import ChooseWifi from "./BuyFlowStep/ChooseWifi";
import useCalculators from "../helpers/useCalculators";
import ChoosePhone from "./BuyFlowStep/ChoosePhone";
import { unauthenticatedApi } from "../Api";
import OrderSummary from "./BuyFlowStep/OrderSummary";
import OrderCustomer from "./BuyFlowStep/OrderCustomer";
import OrderPayment from "./BuyFlowStep/OrderPayment";
import OrderComplete from "./BuyFlowStep/OrderComplete";
import { defaultSession } from "../helpers/defaults";
import { dataLayerPush } from "../helpers/analytics";

let isLoaded = false;

// https://www.30secondsofcode.org/react/s/use-unload/
const useUnload = fn => {
    const cb = useRef(fn);

    useEffect(() => {
      const onUnload = cb.current;
      window.addEventListener('beforeunload', onUnload);
      return () => {
        window.removeEventListener('beforeunload', onUnload);
      };
    }, [cb]);
  };

const BuyFlow = (props) => {    
    
    const {actions, state, getState} = useStateMachineWrapper();

    const clearEverything = (reload = true) => {
        try {
            actions.update({...defaultSession});
            window.sessionStorage.removeItem('sessID');
            window.sessionStorage.removeItem('orderID');

            setCookie('lastStep', 0, 1);
        } catch(e){}

        if(reload) {
            window.location.reload();
        }
    }

    const toggleDb = () => {
        clearEverything(false);
        if(isTestEndpoint()) {
            window.location = '/residential-signup/';
        } else {
            window.location = '/residential-signup-testing/';
        }
    }

    useEffect(() => {
        if(state.session.page == 'loading') {
            actions.update({page: 'intro'});
        }

        // this will remove the session storage one time on page load if the order is complete
        if(state.session.page === 'order-complete' || state.session.page === 'presale-notify-complete') {
            clearEverything();
        }
    }, []);

    useEffect(() => {
        const res = sessionStorage.getItem('bfAdd');        
        const obj = res ? JSON.parse(res) : null;  
        //console.log('buyflow useeffect');      
        if(obj && obj.fromSearchComponent === 1){
           // console.log('from home');
            //state.session.page = 'loading';
            //actions.setPage('loading');
            obj.fromSearchComponent = 0;
            const address = obj.address;
                   
            const jsonAddress = JSON.stringify(obj);

            sessionStorage.setItem('bfAdd', jsonAddress);
            actions.update({
                currentAddress: address,
                addressStatus: address.fiber_status,
                mainLine: address.main_line,    
                fullAddress: address.full_address,                
                addressZip: address.fill_zip,
                address: address.fill_address,
                addressID: address.id,
                city: address.city,
                cityID: address.city_id,
                apt: address.fill_apt,
                state: address.state,
                zip: address.fill_zip,
                //ip: typeof _I3_USER_IP !== 'undefined' ? _I3_USER_IP : '',                 
                marketID: address.market_id,
                sector: address.sector,                
                promoID: '',
                promoName: '',
                promo: null,
                speed: '',
                speedAmount: '',
            });
    
            if(address.fill_zip) {
                setCookie('zip', address.fill_zip, 30);
            }
    
            if(address.redirect_signup !== false) {
                //setSearchValue('');
                actions.setPage('intro');
                window.location.assign(address.redirect_signup);  
                return;
            }
    
            if(address.can_preorder) {
                dataLayerPush({
                    'event' : 'pre-sale'
                });                
                actions.update({isPreorder: true, page: 'presale'});  
                if(!isLoaded) {
                    isLoaded = true;
                    unauthenticatedApi.get(`?endpoint=get-available-services&zip=${address.fill_zip}&market-id=${address.market_id}&sector=${address.sector}`)
                            .then(response => {
                                if(response.status == 200) {
                                    actions.update({availableServices: response.data});
    
                                }
                            });
                }  
                return;
            }
    
            if(!address.signup_available) {
                actions.setPage('address-unavailable');
                return;
            }
    
            dataLayerPush({
                'event' : 'active-sale'
            });    
            if(state.session.page==='choose-internet'){
                actions.update({isPreorder: false, page: 'choose-internet'});
                if(!isLoaded) {
                    isLoaded = true;
                    unauthenticatedApi.get(`?endpoint=get-available-services&zip=${address.fill_zip}&market-id=${address.market_id}&sector=${address.sector}`)
                            .then(response => {
                                if(response.status == 200) {
                                    actions.update({availableServices: response.data});
    
                                }
                            });
                }
                return;
            }
            actions.update({isPreorder: false, page: 'address-available'});
            // always get the available services when loading for the first time
            if(!isLoaded) {
                isLoaded = true;
                unauthenticatedApi.get(`?endpoint=get-available-services&zip=${address.fill_zip}&market-id=${address.market_id}&sector=${address.sector}`)
                        .then(response => {
                            if(response.status == 200) {
                                actions.update({availableServices: response.data});

                            }
                        });
            }
        }
        else{
            // always get the available services when loading for the first time
           // console.log('get data not from home');
            if(!isLoaded && state.session.currentAddress) {
                isLoaded = true;
                unauthenticatedApi.get(`?endpoint=get-available-services&zip=${state.session.currentAddress.fill_zip}&market-id=${state.session.currentAddress.market_id}&sector=${state.session.currentAddress.sector}`)
                        .then(response => {
                            if(response.status == 200) {
                                actions.update({availableServices: response.data});

                            }
                        });
            }
        }
        
    }, []);

    // clear session on page leave if it's complete
    useUnload(e => {
        if(state.session.page == 'presale-notify-complete' || state.session.page == 'order-complete') {
            clearEverything();
        }
    });

    // set sessID if it exists in it's own object
    useEffect(() => {
        if(state.session.sessID == '') {
            let _sessID = window.sessionStorage.getItem('sessID');
            if(_sessID) {
                actions.update({sessID : _sessID});
                window.sessionStorage.removeItem('sessID');
            }
        }
    }, []);

    const {getSubtotal} = useCalculators();

    const [currentZip, setCurrentZip] = useState(getCookie('zip') ?? '');
    const isRiZip = (zip = currentZip) => {
        return [
            '02809',
            '02806',
            '02914',
            '02885',
        ].indexOf(zip) !== -1;
    }

    

    useEffect(() => {
        if(state.session.page === 'loading-mocked') {
            actions.setPage('loading');
            setTimeout(() => {
                actions.setPage('intro');
            }, 1000);
        }
    }, [state.session.page]);

    const shouldShowAddress = () => {
        return state.session.currentAddress && state.session.page != 'order-complete';
    }

    return (        
        <div className="flex flex-col justify-center text-center">
            {isTestEndpoint() && (
                <div id="buyflow-debug-disclaimer" className="rounded-lg"><span className="inline-block mx-auto py-1 px-2 bg-white rounded shadow">This is a test form and will not be processed. Please <a href="https://www.i3broadband.com/residential-signup/" className="text-purple">go here</a> to sign up for our services.</span></div>
            )}

            {shouldShowAddress() && (
            <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-4 gap-4 mt-2">
                <div className="col-span-1 md:text-right">
                    {/* TODO: breadcrubmbs? */}
                </div>
                <div className="col-span-1 md:col-span-2"><p className="text-xs !mb-4 cursor-pointer" onClick={()=>actions.setPage('intro')}><img style={{width: 'auto', height: '1em', display: 'inline'}} src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2047.73%2066.66'%3E%3Cpath%20d='m23.86,0C10.68,0,0,10.68,0,23.86c0,16.88,23.86,42.8,23.86,42.8,0,0,23.86-25.92,23.86-42.8C47.73,10.68,37.05,0,23.86,0Zm0,35.8c-6.59,0-11.93-5.34-11.93-11.93s5.34-11.93,11.93-11.93,11.93,5.34,11.93,11.93-5.34,11.93-11.93,11.93Z'%20fill='%230076b3'/%3E%3C/svg%3E" alt=""/> <span className="underline">{state.session.currentAddress.full_address}</span></p></div>

                <div className="col-span-1 md:text-right">
                    {getSubtotal() > 0 && <div className="-mt-2 mb-4">
                        <svg className="!inline-block !align-baseline mr-1 relative top-px" width={16} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM131.1 80H520.7L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8H161.6L131.1 80zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"/></svg>
                        <span>${getSubtotal()}</span>
                    </div>}
                </div>
            </div>
            )}

            {/* {state.session.page === 'loading' && <BeatLoader speedMultiplier={0.5} className="self-center" />} */}
            {state.session.page === 'loading' && <BounceLoader color={'#8200A8'} speedMultiplier={.75} className="self-center" />}

            {/*
            {isRiZip() === true && (<>
                <a href="/residential-signup/shop/" className="rounded-full self-center py-2 px-6 mb-4 cursor-pointer text-2xl font-bold bg-purple text-white hover:bg-purple-600 mt-4">Sign Up</a>
            </>)}
            */}

            {state.session.page === 'intro' && <Intro/>}
            {state.session.page === 'address-unavailable' && <AddressUnavailable/>}
            {state.session.page === 'address-available' && <AddressAvailable/>}

            {state.session.page === 'presale' && <PreSale/>}
            {state.session.page === 'presale-notify' && <PreSaleNotify/>}
            {state.session.page === 'presale-notify-complete' && <PreSaleNotifyComplete/>}

            {state.session.page === 'choose-internet' && <ChooseInternet/>}
            {state.session.page === 'choose-wifi' && <ChooseWifi/>}
            {state.session.page === 'choose-phone' && <ChoosePhone/>}

            {state.session.page === 'order-summary' && <OrderSummary/>}
            {state.session.page === 'order-customer' && <OrderCustomer/>}
            {state.session.page === 'order-payment' && <OrderPayment/>}

            {state.session.page === 'order-complete' && <OrderComplete/>}

            {isDev() && (
            <div id="buyflow-debug" className="rounded-lg">
                <div>preorder: {state.session.isPreorder ? 'yes' : 'no'} | page: {state.session.page}</div>
                {/* <span>{state.session.page}:&nbsp;</span> */}
                <select onChange={(e) => { actions.setPage(e.target.value); }} value={state.session.page}>
                    {[
                        'loading-mocked',
                        'intro',
                        'address-unavailable',
                        'address-available',

                        'presale',
                        'presale-notify',
                        'presale-notify-complete',

                        'choose-internet',
                        'choose-wifi',
                        'choose-phone',

                        'order-summary',
                        'order-customer',
                        'order-payment',
                        'order-complete',
                        ].map((p) => (
                        <option key={p} value={p}>{p}</option>
                    ))}
                </select>
                <div>
                <span onClick={() => {if(window.confirm('Reset?'))clearEverything()}} className="cursor-pointer inline-block mx-1 mt-1 py-1 px-2 bg-white hover:bg-slate-100 rounded shadow">RESET</span>
                <span onClick={() => {if(window.confirm('Reset & switch?'))toggleDb()}} className="cursor-pointer inline-block mx-1 mt-1 py-1 px-2 bg-white hover:bg-slate-100 rounded shadow">Switch to {isTestEndpoint() ? 'LIVE' : 'TEST'} DB</span>
                </div>
            </div>
            )}
            
        </div>
        
        
    )

};

export default BuyFlow;